export * from './lib/UiArticleSectionFaq';
